export const LOCALES = ["de", "en", "fr", "it"] as const;
export const STATUSES = ["new", "draft", "review", "final"] as const;

export type Locale = (typeof LOCALES)[number];
export type TranslationStatus = (typeof STATUSES)[number];
export type JsonValue = string | number | boolean | null | JsonValue[] | JsonObject;
export type JsonObject = { [key: string]: JsonValue };

export interface ArbDocument {
  locale: Locale;
  filename: string;
  data: JsonObject;
  originalText: string;
}

export interface EntryMetadata {
  description?: string;
  note?: string;
  tags?: string[];
  characterLimit?: number | null;
  status?: Partial<Record<Locale, TranslationStatus>>;
}

export interface MetadataFile {
  schemaVersion: 1;
  entries: Record<string, EntryMetadata>;
}

export interface ValidationIssue {
  level: "error" | "warning";
  code: string;
  message: string;
  key?: string;
  locale?: Locale;
}

export interface OpenedWorkspace {
  directoryHandle: FileSystemDirectoryHandle;
  arbs: Record<Locale, ArbDocument>;
  metadata: MetadataFile;
  normalizedLocales?: Locale[];
  metadataNormalized?: boolean;
  normalizationMessages?: string[];
}

export interface WritableFileHandle extends FileSystemFileHandle {
  createWritable(): Promise<FileSystemWritableFileStream>;
}

export interface DirectoryPickerOptions {
  id?: string;
  mode?: "read" | "readwrite";
  startIn?: string | FileSystemHandle;
}

declare global {
  interface Window {
    showDirectoryPicker?: (options?: DirectoryPickerOptions) => Promise<FileSystemDirectoryHandle>;
  }
}
